var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 30c7.732 0 14-6.268 14-14a13.95 13.95 0 0 0-1.238-5.765h-7.574l-2.47 4.283h3.294c.247.082.757.33.823.659.066.329.028 1.29 0 1.729 0 .33-.164.988-.823.988h-5.024l-4.035 7.824H5.922A13.96 13.96 0 0 0 16 30zM3.557 22.424A13.94 13.94 0 0 1 2 16C2 8.268 8.268 2 16 2c4.12 0 7.824 1.78 10.386 4.612h-7.421l-4.118 7.906H9.988c-.922 0-1.153.549-1.153.823v1.566c0 .725.55.96.824.988h3.293l-2.635 4.53h-6.76z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiro);
export default __webpack_public_path__ + "static/media/FIRO.f8b2bf64e0da7648be364aebfac1d51c.svg";
export { ForwardRef as ReactComponent };